import ProductDescription from './ProductDescription'

const DryBeansProduct = {
  ...ProductDescription,
  category: '06',
  subCategory: '002',
  IsBroadband: true,
  BeanPeaLentilSize: '',
  Organic: false,
}

export default DryBeansProduct
